import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  TextField,
  CircularProgress,
} from '@mui/material';

interface TextCreationDialogProps {
  onCreate: (filename: string, content: string) => Promise<void>;
  children: (openDialog: () => void) => React.ReactNode;
  isCreating?: boolean;
  lang?: 'en' | 'zh-CN' | 'zh-HK';
}

function TextCreationDialog({ onCreate, children, isCreating = false, lang = 'en' }: TextCreationDialogProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [filename, setFilename] = useState('');
  const [content, setContent] = useState('');

  const handleClose = () => {
    setIsOpen(false);
    setFilename('');
    setContent('');
  };

  const handleConfirm = async () => {
    if (!filename || !content) return;
    await onCreate(filename, content);
    handleClose();
  };

  return (
    <>
      {children(() => setIsOpen(true))}

      <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>{lang === 'en' ? 'Create Text Material' : lang === 'zh-HK' ? '创建文本材料' : '创建文本材料'}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={2}>
            <TextField
              variant="outlined"
              fullWidth
              label={lang === 'en' ? 'Filename' : '文件名'}
              value={filename}
              onChange={e => setFilename(e.target.value)}
            />
            <TextField
              variant="outlined"  
              fullWidth
              placeholder={lang === 'en' ? 'Enter text or paste from clipboard. Max 10000 characters' : '输入文本或从剪贴板粘贴。最多10000字'}
              multiline
              rows={10}
              label={lang === 'en' ? 'Content' : lang === 'zh-HK' ? '内容' : '内容'}
              value={content}
              onChange={e => setContent(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={isCreating}>{lang === 'en' ? 'Cancel' : lang === 'zh-HK' ? '取消' : '取消'}</Button>
          <Button disabled={!filename || !content || isCreating} onClick={handleConfirm} startIcon={isCreating ? <CircularProgress size={20} /> : undefined}>
            {lang === 'en' ? 'Create' : lang === 'zh-HK' ? '创建' : '创建'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default TextCreationDialog;
